var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCsf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26417_23744)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.0007 27.9546C56.0007 38.8651 49.5831 48.8957 39.6489 53.471C25.5828 59.8941 8.96715 53.647 2.54948 39.657C0.87913 35.9615 0 32.0901 0 28.0426C0 17.1322 6.41767 7.10157 16.3519 2.52621C23.1212 -0.553355 30.7696 -0.817326 37.7148 1.73432C44.7478 4.37394 50.2864 9.56522 53.3633 16.3403C55.2095 20.0358 56.0007 23.9952 56.0007 27.9546Z",
    fill: "#F4CD00"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_26417_23744)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3314 15.5429V40.0462H40.8347C41.2695 40.0462 41.6217 40.3984 41.6217 40.8332C41.6217 41.268 41.2695 41.6202 40.8347 41.6202H16.1174C15.3661 41.6202 14.7568 41.0114 14.7568 40.2602V15.5429C14.7568 15.1081 15.1096 14.7559 15.5444 14.7559C15.9791 14.7559 16.3314 15.1081 16.3314 15.5429Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4717 24.8213H37.2305C37.3135 24.8213 37.3807 24.8887 37.3809 24.9717V37.7549C37.3809 37.838 37.3136 37.9052 37.2305 37.9053H33.4717C33.3887 37.9051 33.3213 37.8379 33.3213 37.7549V24.9717C33.3215 24.8888 33.3888 24.8215 33.4717 24.8213Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.13514
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2148 27.9697H30.1104C30.1556 27.9698 30.1922 28.0065 30.1924 28.0518V37.8232C30.1924 37.8686 30.1557 37.9062 30.1104 37.9062H26.2148C26.1696 37.906 26.1328 37.8685 26.1328 37.8232V28.0518C26.133 28.0066 26.1697 27.9699 26.2148 27.9697Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.13514
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0039 31.1162V37.9043H18.9443V31.1162H23.0039Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.13514
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2608 17.1235L36.1626 21.1564L34.6453 20.7342L35.0076 19.4488L34.9329 19.3742L20.2674 27.5906L20.136 27.5602L19.4336 26.3163L34.2752 17.9563L32.8605 17.5352C32.8132 17.481 33.166 16.2598 33.2217 16.142C33.2448 16.0931 33.2495 16.0379 33.3126 16.0195L37.2608 17.123V17.1235Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26417_23744"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_26417_23744"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.8649,
    height: 26.8649,
    fill: "white",
    transform: "translate(14.7568 14.7559)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsf);
export default __webpack_public_path__ + "static/media/csf.70d035e4db39b5a2c7571af907ec6cf3.svg";
export { ForwardRef as ReactComponent };